var BlockView = require('views/block/base-block-view');
var FeedbackService = require('services/feedback-service');
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');

var activeDropId = 'drop-1';
const DragAndDropKeyboard = require('services/drag-and-drop-keyboard-service'),
  DRAG_SELECTOR = '.draggable',
  DROP_SELECTOR = '.droppable';

var DragNDropView = BlockView.extend({
  initialize: function () {
    var normalizeHeaderDesc = el => {
      if (el.header && typeof el.header !== 'object') {
        el.header = { text: el.header };
      }
      if (el.description && typeof el.description !== 'object') {
        el.description = { text: el.description };
      }
    };
    _.each(this.model.get('draggables'), normalizeHeaderDesc);
    _.each(this.model.get('droppables'), normalizeHeaderDesc);
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function () {
    var self = this;

    this.renderMultipleNestedBlocks('draggables');
    this.renderMultipleNestedBlocks('droppables');

    self.addAccessibilityInfo(self);

    _.each(this.model.get('draggables'), function (drag_data) {
      var drag_options = {
        start: function (e, ui) {
          $(this).addClass('dragging');
          if (self.model.get('use_zoom_scale')) {
            $(this).attr('orig-left', $(this).position().left);
            $(this).attr('orig-top', $(this).position().top);
            ui.position.left = 0;
            ui.position.top = 0;
          }
        },
        stop: function (e, ui) {
          $(this).removeClass('dragging');
        },
        drag: function (e, ui) {
          var scaleX = e.target.getBoundingClientRect().width / e.target.offsetWidth;
          var changeLeft = ui.position.left - ui.originalPosition.left; // find change in left
          var newLeft = ui.originalPosition.left + changeLeft / scaleX; // adjust new left by our zoomScale

          var scaleY = e.target.getBoundingClientRect().height / e.target.offsetHeight;
          var changeTop = ui.position.top - ui.originalPosition.top; // find change in top
          var newTop = ui.originalPosition.top + changeTop / scaleY; // adjust new top by our zoomScale

          ui.position.left = newLeft;
          ui.position.top = newTop;
        },
        revert: function (droppable) {
          //if not a valid droppable, then revert
          if (!droppable || !this.attr('data-droppable')) {
            if (self.model.get('use_zoom_scale')) {
              var matrix = self.getTransformMatrix();
              var zoomScale = matrix !== undefined ? parseFloat(matrix[0]) : 1.0;

              var revertPos = {
                left: parseFloat($(this).attr('orig-left')) * (1.0 / zoomScale),
                top: parseFloat($(this).attr('orig-top')) * (1.0 / zoomScale),
              };
              $(this).data('ui-draggable').originalPosition = revertPos;
            }
            return true;
          }
        },
      };

      //TODO: make cloning a draggable work
      //if (draggable.clone){
      //  drag_options.helper = "clone";
      //}

      if (self.model.get('draggables_in_sequence')) {
        drag_options.disabled = true;
      }
      self.$('#' + drag_data.id).draggable(drag_options);
    });

    _.each(this.model.get('droppables'), function (drop_data) {
      drop_data.correct = self.stringToArray(drop_data.correct);

      if (drop_data.correct_draggables_required === undefined) {
        if (drop_data.correct === undefined || drop_data.correct === true) {
          drop_data.correct_draggables_required = self.model.get('draggables').length;
        } else if (drop_data.correct === false) {
          drop_data.correct_draggables_required = 0;
        } else {
          drop_data.correct_draggables_required = drop_data.correct.length;
        }
      }

      var drop_options = {
        drop: function (event, ui) {
          var drag_data = _.find(self.model.get('draggables'), { id: ui.draggable.attr('id') });
          var droppable = $(this);
          var draggable = ui.draggable;
          self.dropDraggable(draggable, drag_data, droppable, drop_data);
        },
        over: function (e, ui) {
          //$(this).droppable('option', 'tolerance', 'pointer');
          ui.draggable.addClass('dragging-over');
          $(this).addClass('drop-over');
        },
        out: function (e, ui) {
          ui.draggable.removeClass('dragging-over');
          $(this).removeClass('drop-over');
        },
        tolerance: 'touch',
      };
      if (self.model.get('droppables_in_sequence')) {
        drop_options.disabled = true;
      }

      self.$('#' + drop_data.id).droppable(drop_options);
    });

    this.handleKeyDown();
    Chaplin.mediator.subscribe(
      'drop:draggable',
      (draggableId, droppableId) => {
        var drag_data = _.find(this.model.get('draggables'), { id: draggableId });
        var drop_data = _.find(this.model.get('droppables'), { id: droppableId });
        var draggable = $('#' + draggableId);
        var droppable = $('#' + droppableId);
        this.dropDraggable(draggable, drag_data, droppable, drop_data);
      },
      this
    );

    if (this.model.get('draggables_in_sequence')) {
      this.$('#' + this.model.get('draggables')[0].id).draggable('enable');
    }
    if (this.model.get('droppables_in_sequence')) {
      this.$('#' + this.model.get('droppables')[0].id).droppable('enable');
    }

    Chaplin.mediator.subscribe(
      'drop:setActive',
      droppableId => {
        activeDropId = droppableId;
      },
      this
    );
  },
  dropDraggable: function (draggable, drag_data, droppable, drop_data) {
    //TODO: make cloning work for draggable elements
    //clone element if clone is true - need to make sure it doesn't mess up the counts
    //$(ui.helper).clone(true).removeClass('box ui-draggable ui-draggable-dragging').appendTo('.activity_holder');
    if (!drag_data || !drop_data) {
      return;
    }

    //if too many draggables here, do nothing, will get reverted
    var currentDraggables = $('[data-droppable="' + drop_data.id + '"][data-correct="true"]').length;
    if (currentDraggables >= drop_data.draggables_allowed) {
      this.addDropFeedback(drag_data, false, 'dropSpotTaken');
      return;
    } else if (drop_data.correct_draggables_required <= currentDraggables + 1) {
      droppable.addClass('completed');
    }

    var correct = drop_data.correct === true || drop_data.correct.indexOf(draggable.attr('id')) >= 0;
    var origDroppable = draggable.attr('data-droppable');

    if (correct) {
      this.addDropFeedback(drag_data, true);
      if (this.model.get('a11y_info') !== undefined) {
        $(`#${drag_data.id}`).tooltip('hide');
        $(`#${drag_data.id}`).tooltip('destroy');
      }
    } else {
      this.addDropFeedback(drag_data, false, 'incorrect');
    }

    //only set data-droppable if we want it to stay on the drop zone
    if (correct || drop_data.keep_incorrect_drops) {
      draggable.attr('data-droppable', drop_data.id);
      droppable.attr('data-total-accepted', parseInt(droppable.attr('data-total-accepted') || 0) + 1);
    }

    if (origDroppable !== draggable.attr('data-droppable') || !origDroppable) {
      draggable.attr('data-correct', correct);
    }

    draggable.removeAttr('title');
    draggable.removeClass('dragging-over');
    draggable.addClass('dropped');

    droppable.removeClass('drop-over');
    droppable.addClass('droppable-dropped');

    AhoyService.track('drag-n-drop', {
      action: 'drop',
      draggable: draggable.attr('id'),
      droppable: droppable.attr('id'),
      correct: correct,
    });

    if (drop_data.append_draggables && correct) {
      droppable.find('ul').append(draggable);
      draggable.attr('role', 'listitem');
      if (drop_data.append_draggables_maintain_dimensions) {
        draggable.css({ top: '', left: '', bottom: '', right: '' });
      } else {
        draggable.css({ top: '', left: '', bottom: '', right: '', height: '', width: '' });
      }
    }

    if (correct && this.model.get('disable_correct_drop')) {
      this.$('#' + this.model.get('draggables')[drag_data.index].id).draggable('disable');
    }

    Chaplin.mediator.publish('block:draggable:dropped', {
      drop_data: drop_data,
      drag_data: drag_data,
      correct: correct,
      index: drop_data.index,
    });

    var feedback = drop_data.feedback ? drop_data.feedback : drag_data.feedback;
    var feedbackState = correct ? 'correct' : 'incorrect';
    draggable.addClass(feedbackState);

    var self = this;
    var possibleStates = ['correct', 'incorrect'];
    FeedbackService.renderFeedbackWithElementState(feedback, droppable, feedbackState, possibleStates, {
      completed: function () {
        self.checkComplete();
      },
      noFeedback: _.bind(this.checkComplete, this),
    });

    if (correct && this.model.get('draggables_in_sequence')) {
      this.enableNextInSequence(this.model.get('draggables'), drag_data.index, function (next) {
        $('#' + next.id).draggable('enable');
        $('#' + next.id).addClass('drag-enabled');
      });
    }
    if (correct && this.model.get('droppables_in_sequence')) {
      this.enableNextInSequence(this.model.get('droppables'), drop_data.index, function (next) {
        $('#' + next.id).droppable('enable');
      });
    }

    self.addAccessibilityInfo(self);
  },
  play: function () {
    this.checkComplete();
  },
  checkComplete: function () {
    if (this.model.get('complete_on_draggables')) {
      var drags_correct = _.every(this.model.get('draggables'), function (drag_check) {
        return $('#' + drag_check.id).attr('data-correct') === 'true';
      });

      if (drags_correct) {
        AhoyService.track('drag-n-drop', { action: 'completed' });
        this.readyToGo();
      }
    } else {
      var all_correct = _.every(this.model.get('droppables'), function (drop_check) {
        return (
          drop_check.correct_draggables_required ===
          $('[data-droppable="' + drop_check.id + '"][data-correct="true"]').length
        );
      });

      if (all_correct) {
        AhoyService.track('drag-n-drop', { action: 'completed' });
        this.readyToGo();
      }
    }
  },

  handleKeyDown: function (e) {
    var onKeyboardMove = _.bind(function (draggable, droppable) {
      var dropId = activeDropId === 'drop-1' ? droppable.attr('id') : activeDropId;
      var drag_data = _.find(this.model.get('draggables'), { id: draggable.attr('id') });
      var drop_data = _.find(this.model.get('droppables'), { id: dropId });

      this.dropDraggable(draggable, drag_data, droppable, drop_data);
    }, this);
    const keyb = new DragAndDropKeyboard(this.$el, DRAG_SELECTOR, DROP_SELECTOR, onKeyboardMove);
    keyb.init(this.model);
  },

  stringToArray: function (val) {
    return typeof val === 'string' ? [val] : val;
  },
  enableNextInSequence: function (array, current_index, enable_fn) {
    var next = _.find(array, function (item) {
      return item.index > current_index;
    });
    if (next) {
      enable_fn(next);
    }
  },
  getTransformMatrix: function () {
    var obj = $('#page-container');
    var tMatrix =
      obj.css('transform') ||
      obj.css('-webkit-transform') ||
      obj.css('-moz-transform') ||
      obj.css('-ms-transform') ||
      obj.css('-o-transform');
    if (tMatrix !== undefined && tMatrix !== 'none') {
      return tMatrix.replace(/[^0-9\-.,]/g, '').split(',');
    } else {
      return undefined;
    }
  },
  addAccessibilityInfo: function (self) {
    let a11yInfo = self.model.get('a11y_info');
    if (!a11yInfo) {
      return;
    }
    let dropLabelSource = a11yInfo.source;
    let startChar = 65;
    let endChar = 90;
    let allDroppables = [];
    let tooltip = a11yInfo.tooltip;

    _.each(this.model.get('droppables'), function (drop_data) {
      allDroppables.push(drop_data);
    });

    $(DRAG_SELECTOR).each(function (index, elem) {
      endChar = startChar + allDroppables.length - 1;
      let firstOptionCharCode = 65;
      let firstOption = String.fromCharCode(startChar);
      let lastOption = String.fromCharCode(endChar);
      let label = '';

      if (a11yInfo.remove_keyboard_options) {
        label = LocaleService.t('dragAndDrop.single');
      }

      if (allDroppables.length > 1 && !a11yInfo.remove_keyboard_options) {
        label = LocaleService.t('dragAndDrop.multiple', { firstOption: firstOption, lastOption: lastOption });

        for (var i = 0; i < allDroppables.length; i++) {
          let dropSpotLabel = '';
          let text = '';
          let separatorSymbol = i + 1 === allDroppables.length ? '.' : ',';
          let linkWord = LocaleService.t('dragAndDrop.linkWord');

          switch (dropLabelSource) {
            case 'dropDescription':
              dropSpotLabel = self.getLabel(allDroppables[i], 'description');
              text = ` ${firstOption} ${linkWord} ${dropSpotLabel}${separatorSymbol}`;
              break;

            case 'dropId':
              dropSpotLabel = self.getLabel(allDroppables[i], 'id');
              text = ` ${firstOption} ${linkWord} ${dropSpotLabel}${separatorSymbol}`;
              break;

            default:
              dropSpotLabel = self.getLabel();
              text = ` ${firstOption} ${linkWord} ${dropSpotLabel} ${i + 1}${separatorSymbol}`;
          }

          firstOptionCharCode++;
          firstOption = String.fromCharCode(firstOptionCharCode);
          label = label.concat(text);
        }
      }

      if (a11yInfo.custom_instructions) {
        label = LocaleService.t(a11yInfo.custom_instructions);
      }

      if (tooltip) {
        let tooltipPlacement = tooltip.placement ? tooltip.placement : 'top';
        let tooltipDelay = tooltip.delay ? tooltip.delay : 1000;

        $(elem).tooltip({
          template: `<div class="tooltip drag-drop-tooltip" role="tooltip" aria-live='polite' aria-atomic='true'><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>`,
          trigger: 'focus',
          container: 'body',
          delay: { show: tooltipDelay, hide: 0 },
          title: label,
          placement: tooltipPlacement,
        });
      }
      setTimeout(function () {
        if ($(elem).data('correct')) {
          label = LocaleService.t('dragAndDrop.dropped');
          $(elem).tooltip('hide');
          $(elem).tooltip('destroy');
        }
      }, 0);
    });
  },
  getLabel: function (dropSpot, source) {
    if (dropSpot) {
      if (source === 'id') {
        return dropSpot.id;
      } else if (source === 'description') {
        if (dropSpot.header && dropSpot.header.text) {
          return LocaleService.t(dropSpot.header.text);
        } else if (dropSpot.description && dropSpot.description.text) {
          return LocaleService.t(dropSpot.description.text);
        } else if (dropSpot.blocks) {
          if (dropSpot.blocks.constructor === Array) {
            let blocks = dropSpot.blocks;
            let label = '';

            for (var i = 0; i < blocks.length; i++) {
              if (blocks[i].type === 'text') {
                let currentBlockArray = blocks[i].items;

                for (var j = 0; j < currentBlockArray.length; j++) {
                  let text = currentBlockArray[j].description && currentBlockArray[j].description.text;
                  label = label.concat(LocaleService.t(text));
                }
              }
            }
            return label;
          }
        }
      } else {
        return LocaleService.t('dragAndDrop.default');
      }
    } else {
      return LocaleService.t('dragAndDrop.default');
    }
  },
  addDropFeedback: function (dragData, success, messageType) {
    if (!this.model.get('a11y_info') || !this.model.get('a11y_info').feedback) {
      return;
    }
    let a11yInfo = this.model.get('a11y_info');
    let a11yInfoFeedback = a11yInfo.feedback;
    let left = a11yInfoFeedback.position ? a11yInfoFeedback.position.left : '42%';
    let top = a11yInfoFeedback.position ? a11yInfoFeedback.position.top : '88%';
    let dismissTimeout = a11yInfoFeedback.dismiss_timeout || 5000;
    let label = '';

    if (success) {
      if (dragData.feedback) {
        // hide this feedback if there's a popover feedback
        setTimeout(function () {
          $('.drop-alert').addClass('hide');
        }, 0);
      } else {
        $('.drop-alert').addClass('alert-success').removeClass('alert-danger');
        label = LocaleService.t('dragAndDrop.success');
      }
      $('.drop-alert').addClass('alert-success').removeClass('alert-danger');
      label = LocaleService.t('dragAndDrop.success');
    } else {
      switch (messageType) {
        case 'dropSpotTaken':
          label = LocaleService.t('dragAndDrop.dropSpotTaken');
          break;

        case 'incorrect':
          label = LocaleService.t('dragAndDrop.incorrect');
          break;
        default:
          break;
      }
      $('.drop-alert').addClass('alert-danger').removeClass('alert-success');
    }

    $('.drop-alert').css({ position: 'fixed', left: left, top: top }).text(label).removeClass('hide');

    // automatically remove feedback after a timeout
    setTimeout(function () {
      $('.drop-alert').addClass('hide');
    }, dismissTimeout);
  },
});

module.exports = DragNDropView;
